<template>
  <v-card flat class="setup-subtab-content">
    <div>

      <div class="">
        <div class="font-weight-bold">
          {{ $t('setup.counterVersion') }}
        </div>
        <div v-if="!publisherCounterVersion">
          {{ $t('setup.counterVersionDescNoVersion') }}
        </div>
        <div v-if="publisherCounterVersion === 4">
          {{ $t('setup.counterVersionDescV4') }}
        </div>
        <div v-if="publisherCounterVersion === 5">
          {{ $t('setup.counterVersionDescV5') }}
        </div>

        <div class="pa-3">
          <v-radio-group
              class="mt-0"
              v-model="counterFileType"
          >
            <v-radio
                value="counter-4"
                label="COUNTER 4"
                :disabled="publisherCounterVersion === 5"
            />
            <v-radio
                value="counter-5"
                label="COUNTER 5"
                :disabled="publisherCounterVersion === 4"
            />
          </v-radio-group>

        </div>
      </div>
      <div class="font-weight-bold mt-10 mb-1">
        {{ $t('setup.counterReportFiles') }}
      </div>
      <div v-if="counterFileType==='counter-5'">
        <div v-html="$t('setup.counter5Instructions')">
        </div>
        <v-list>
          <publisher-file file-type="counterTrj2"/>
          <publisher-file file-type="counterTrj3"/>
          <publisher-file file-type="counterTrj4"/>
        </v-list>
      </div>
      <div v-if="counterFileType==='counter-4'">
        <div>
          {{ $t('setup.counter4Instructions') }}
        </div>
        <v-list>
          <publisher-file file-type="counter"/>

        </v-list>
      </div>

    </div>
  </v-card>


</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import PublisherFile from "@/components/PulisherFile/PublisherFile";
import PublisherWarning from "@/components/PublisherWarning/PublisherWarning";


export default {
  name: "PublisherSetupTab",
  components: {
    PublisherFile,
    PublisherWarning,
  },
  props: {},
  data() {
    return {
      counterFileType: "counter-5",
      isUploadFileLoading: false, // temporary to silence console errors
      fileSelected: null,
      errorMsg: null,


    }
  },
  methods: {},
  computed: {
    ...mapGetters([
      "publisherName",
      "publisherId",
      "publisherBigDealCost",
      "publisherFiles",
      "getPublisherDataFile",
      "publisherCounterVersion",
        "getPublisherWarning",
    ]),
  },
  created() {
    if (this.publisherCounterVersion === 4) {
      this.counterFileType = "counter-4"
    }
    else {
      this.counterFileType = "counter-5"
    }
  },
  mounted() {

  },
  watch: {}
}
</script>

<style lang="scss">


</style>
